module.exports = __webpack_public_path__ + "img/desc_bottom_blpjs01.bbddb01b.png";